import {
  createContext,
  createPortal,
  type FC,
  type ReactNode,
} from "preact/compat";
import { useContext } from "preact/hooks";
import { ModalContext } from "@components/ComboBoxes/ComboboxModalProvider";

export type ComboboxModalProps = {
  children: ReactNode;
};

export const ComboboxModal: FC<ComboboxModalProps> = ({ children }) => {
  const modalNode = useContext(ModalContext);
  return modalNode
    ? createPortal(
        <div className="combobox-modal fixed overflow-hidden inset-0 top-0 left-0 z-50 w-screen h-auto bg-neutral-900/[0.4] backdrop-blur">
          {children}
        </div>,
        modalNode,
      )
    : null;
};
